import React, { useState, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function VehicleUtilizationChart({ data: chartData = [] }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Use props data if available, fallback to mock data
  const defaultData = [
    { route: 'Delhi to Noida', assigned: 10 },
    { route: 'Noida to Faridabad', assigned: 20 },
    { route: 'Faridabad to Gurgaon', assigned: 15 },
    { route: 'Gurgaon to Delhi', assigned: 25 },
    { route: 'Delhi to Gurgaon', assigned: 18 },
    { route: 'Noida to Delhi', assigned: 12 }
  ];

  const dataToUse = chartData.length > 0 ? chartData : defaultData;

  const data = {
    labels: dataToUse.map(item => item.route),
    datasets: [
      {
        label: 'Number of Assigned',
        data: dataToUse.map(item => item.assigned),
        backgroundColor: [
          'rgba(54, 162, 235, 0.8)',   // Blue for Delhi-Noida
          'rgba(75, 192, 192, 0.8)',   // Teal for Noida-Faridabad
          'rgba(255, 99, 132, 0.8)',   // Red for Faridabad-Gurgaon
          'rgba(255, 206, 86, 0.8)',   // Yellow for Gurgaon-Delhi
          'rgba(153, 102, 255, 0.8)',  // Purple for Delhi-Gurgaon
          'rgba(255, 159, 64, 0.8)',   // Orange for Noida-Delhi
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',     // Blue for Delhi-Noida
          'rgba(75, 192, 192, 1)',     // Teal for Noida-Faridabad
          'rgba(255, 99, 132, 1)',     // Red for Faridabad-Gurgaon
          'rgba(255, 206, 86, 1)',     // Yellow for Gurgaon-Delhi
          'rgba(153, 102, 255, 1)',    // Purple for Delhi-Gurgaon
          'rgba(255, 159, 64, 1)',     // Orange for Noida-Delhi
        ],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
      mode: 'index',
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 14,
            weight: 'bold',
          },
        },
      },
      title: {
        display: true,
        text: 'Bus Assigned per Route',
        font: {
          size: 18,
          weight: 'bold',
        },
        color: '#333',
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#ddd',
        borderWidth: 1,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Number of Assigned',
          font: {
            size: 14,
            weight: 'bold',
          },
          color: '#333',
        },
        ticks: {
          font: {
            size: windowWidth < 768 ? 10 : 12,
          },
          color: '#666',
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Routes',
          font: {
            size: 14,
            weight: 'bold',
          },
          color: '#333',
        },
        ticks: {
          font: {
            size: windowWidth < 768 ? 10 : 12,
          },
          color: '#666',
          maxRotation: windowWidth < 480 ? 90 : windowWidth < 768 ? 60 : 45,
          minRotation: 0,
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div className="chart-container">
      <div className="chart-wrapper">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}

export default VehicleUtilizationChart;
